import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectToArray'
})
export class ObjectToArrayPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!(value && !Array.isArray(value))) { return value; }
    const array = [];
    for (const key in value) {
      array.push({ key: key, value: value[key]});
    }
    return array;
  }

}
